var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#3779E1",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1211 14.8906H21.8711C21.0742 14.8906 20.5938 14.7031 20.0078 14.1992L19.293 13.6133C18.5195 12.957 17.9219 12.7461 16.7617 12.7461H13.4219C11.3711 12.7461 10.1875 13.918 10.1875 16.2734V19.4141H36.8008V18.5234C36.8008 16.1094 35.5586 14.8906 33.1211 14.8906ZM13.8672 34.1914H33.4727C35.5703 34.1914 36.8008 32.9727 36.8008 30.5586V20.9492H10.1875V30.5586C10.1875 32.9844 11.418 34.1914 13.8672 34.1914Z",
    fill: "#3779E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.1008184b505c4c64595caa3103f2fcc1.svg";
export { ForwardRef as ReactComponent };